const events = [
  {
    id: 1,
    title: "1 St Year Parking lot bash",
    date: "May 17–19, 2026",
    location: "Black Hills, SD",
    type: "Rally",
    description: "Our 1st Anniversary Annual Parking Lot Party, Food, Drinks, Live Music, Motorcycle Line Up & Much More... August 30th 2026 Rochester New York",
    image: "https://public.readdy.ai/ai/img_res/a5a3f1c65e8819ba6fd592226888631e.jpg",
  },
  {
    id: 2,
    title: "",
    date: "June 7, 2026",
    location: "Chicago, IL",
    type: "Ponderosa Run",
    description: "A 200-mile Brother &amp; Sister Ponderosa Steakhouse Run to Butler P.A for Fellowship &amp; Fun June/July 2026 Leave From Rochester NY Destination Butler P.A",
    image: "https://readdy.ai/api/search-image?query=motorcycle%20poker%20run%20night%20ride%20city%20streets%20headlights%20glowing%20long%20exposure%20photography%2C%20urban%20environment%2C%20moody%20dramatic%20atmosphere%2C%20multiple%20bikes%20in%20formation&width=600&height=400&seq=event002&orientation=landscape",
  },
  {
    id: 3,
    title: "Family & Fun",
    date: "July 4, 2026",
    location: "Chapter HQ, Detroit, MI",
    type: "Social Club Meet & Greet",
    description: "&nbsp;Bring your family and your ride. June/July 2026 Rochester New York",
    image: "https://readdy.ai/api/search-image?query=outdoor%20motorcycle%20club%20cookout%20gathering%20backyard%20party%2C%20custom%20bikes%20parked%20on%20display%2C%20people%20socializing%2C%20grill%20smoke%2C%20summer%20day%2C%20american%20flags%2C%20candid%20documentary&width=600&height=400&seq=event003&orientation=landscape",
  },
];

const typeColors: Record<string, string> = {
  "Rally": "bg-red-900/60 text-red-400",
  "Ponderosa Run": "bg-yellow-900/60 text-yellow-400",
  "Social Club Meet & Greet": "bg-green-900/60 text-green-400",
};

export default function EventsSection() {
  return (
    <section id="events" className="w-full bg-[#0d0d0d] py-24 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-red-500 uppercase tracking-[0.3em] text-xs font-bold mb-3">On the Calendar</p>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              Upcoming Events
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-sm">Don&apos;t miss a ride. Mark your calendar and roll with the brotherhood.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map((event) => (
            <div key={event.id} className="bg-[#1a1a1a] group overflow-hidden cursor-pointer hover:border-red-700 border border-[#2a2a2a] transition-all duration-300">
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              </div>
              <div className="p-6">
                <span className={`inline-block text-xs uppercase tracking-wider font-bold px-3 py-1 rounded-sm mb-3 ${typeColors[event.type]}`}>
                  {event.type}
                </span>
                <h3 className="text-xl font-black text-white mb-2 uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                  {event.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{event.description}</p>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
